export const baseUrl = state => {
  return state.baseUrl;
};
export const getMode = state => {
  return state.mode;
};
export const getServer = state => {
  return state.server;
};
export const getImage = state => {
  console.log("getters js ", state);
  return state.docImage;
};
export const getUserInfo = state => {
  console.log("getter ", state);
  return state.userInfo;
};
export const getItemsInfoCart = state => {
  return state.getCartDetails;
};
export const getSurveyQuestions = state => {
  return state.surveyQuestions;
};
export const getSurveyPageNum = state => {
  return state.pageNum;
};
export const getCartDataDetails = state => {
  return state.cartData
};
export const getCTAImages = state => {
  return state.CTAImages
};
export const getCartDetails = state => {
  return state.CartDetails
};
export const getBBDetails = state => {
  return state.bbDetails
};


// WEBPACK FOOTER //
// ./src/store/getters.js